import { render } from "./InternationalGuideline.vue?vue&type=template&id=c372fd94&scoped=true"
import script from "./InternationalGuideline.vue?vue&type=script&lang=js"
export * from "./InternationalGuideline.vue?vue&type=script&lang=js"

import "./InternationalGuideline.vue?vue&type=style&index=0&id=c372fd94&scoped=true&lang=css"

import exportComponent from "/var/www/html/bcsprostuti-web-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c372fd94"]])

export default __exports__